import React from 'react';
// Remove Parallax imports
// import { Parallax, ParallaxLayer } from '@react-spring/parallax';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useSpring, animated } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import './Home.css';
import CompMarquee from '../Components/CompMarquee';
import CompContactWidget from '../Components/CompContactWidget';
import UXImgHomeFeature1 from '../Assets/Images/uxi-2025-home-feature1.png';
import UXImgHomeFeature2 from '../Assets/Images/uxi-2025-home-feature2.png';
import UXImgHomeFeature3 from '../Assets/Images/uxi-2025-home-feature3.png';
import UXImgHomeFeature4 from '../Assets/Images/uxi-2025-home-feature4.png';
import UXImgHomeFeature5 from '../Assets/Images/uxi-2025-home-feature5.png';
import UXImgHomeFeature6 from '../Assets/Images/uxi-2025-home-feature6.png';
import UXImgHomeFeature7 from '../Assets/Images/uxi-2025-home-feature7.png';
import UXImgHomeFeature8 from '../Assets/Images/uxi-2025-home-feature8.png';
import UXImgHomeFeature9 from '../Assets/Images/uxi-2025-home-feature9.png';
import UXImgHomeFeature10 from '../Assets/Images/uxi-2025-home-feature10.png';

function useFadeInSpring(inView, delay) {
  return useSpring({ opacity: inView ? 1 : 0, transform: inView ? 'translateY(0)' : 'translateY(20px)', delay });
}

function Home() {
  const { ref: ref1, inView: inView1 } = useInView({ triggerOnce: true });
  const { ref: ref2, inView: inView2 } = useInView({ triggerOnce: true });
  const { ref: ref3, inView: inView3 } = useInView({ triggerOnce: true });
  const { ref: ref4, inView: inView4 } = useInView({ triggerOnce: true });
  const { ref: ref5, inView: inView5 } = useInView({ triggerOnce: true });
  const { ref: ref6, inView: inView6 } = useInView({ triggerOnce: false });
  const leftSpring1 = useSpring({ transform: inView1 ? 'translateX(0%)' : 'translateX(-100%)' });
  const rightSpring1 = useSpring({ transform: inView1 ? 'translateX(0%)' : 'translateX(100%)' });
  const leftSpring2 = useSpring({ transform: inView2 ? 'translateX(0%)' : 'translateX(-100%)', delay: 200 });
  const rightSpring2 = useSpring({ transform: inView2 ? 'translateX(0%)' : 'translateX(100%)', delay: 200 });
  const leftSpring3 = useSpring({ transform: inView2 ? 'translateX(0%)' : 'translateX(-100%)', delay: 400 });
  const rightSpring3 = useSpring({ transform: inView2 ? 'translateX(0%)' : 'translateX(100%)', delay: 400 });
  const fadeInSpring1 = useFadeInSpring(inView3, 0);
  const fadeInSpring2 = useFadeInSpring(inView3, 200);
  const fadeInSpring3 = useFadeInSpring(inView3, 400);
  const fadeInSpring4 = useFadeInSpring(inView3, 600);
  const leftSpring4 = useSpring({ transform: inView4 ? 'translateX(0%)' : 'translateX(-100%)' });
  const rightSpring4 = useSpring({ transform: inView4 ? 'translateX(0%)' : 'translateX(100%)' });
  const leftSpring5 = useSpring({ transform: inView4 ? 'translateX(0%)' : 'translateX(-100%)', delay: 200 });
  const rightSpring5 = useSpring({ transform: inView4 ? 'translateX(0%)' : 'translateX(100%)', delay: 200 });
  const leftSpring6 = useSpring({ transform: inView5 ? 'translateX(0%)' : 'translateX(-100%)' });
  const rightSpring6 = useSpring({ transform: inView5 ? 'translateX(0%)' : 'translateX(100%)' });

  const [showArrow, setShowArrow] = React.useState(true);

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const lastSectionTop = document.querySelector('#last-section').offsetTop;
      setShowArrow(scrollTop + windowHeight < documentHeight && scrollTop + windowHeight < lastSectionTop && !inView6);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [inView6]);

  return (
    <div className="scroll-container uxi-home-main-container">
      <CompMarquee height="full" title="Innovate and Disrupt." subTitle="User-centered Design has changed." />
      <Container style={{ marginTop: '32px', marginBottom: '32px' }}>
        <Typography variant="h2" style={{ color: 'white', fontFamily: 'ethnocentric' }}>User-Centered Product Shop</Typography>
        <h3>Products built center out, solving key business problems.</h3>
        <Box ref={ref1} display="flex" alignItems="flex-start" justifyContent="center" height="100%" mb={2}>
          <animated.div style={{ ...leftSpring1, width: '30%' }}>
            <img src={UXImgHomeFeature1} alt="Sample" style={{ width: '100%' }} />
          </animated.div>
          <animated.div style={{ ...rightSpring1, width: '70%', padding: '20px' }}>
            <Typography variant="h4" style={{ color: 'white' }}>Startups</Typography>
            <p>UX Integrity partners with emerging startups to provide tailored UX strategy and design services, helping them bring innovative ideas to life while aligning with critical industry objectives. From early-stage prototypes to refined user experiences, we accelerate product development and ensure every design decision supports growth and impact.</p>
          </animated.div>
        </Box>
        <Box ref={ref2} display="flex" alignItems="flex-start" justifyContent="center" height="100%" mb={2}>
          <animated.div style={{ ...leftSpring2, width: '30%' }}>
            <img src={UXImgHomeFeature2} alt="Sample" style={{ width: '100%' }} />
          </animated.div>
          <animated.div style={{ ...rightSpring2, width: '70%', padding: '20px' }}>
            <Typography variant="h4" style={{ color: 'white' }}>SaaS and Direct-Market Apps</Typography>
            <p>At UX Integrity, we specialize in identifying untapped opportunities where SaaS platforms and direct-to-market applications can deliver real business value. By focusing on the specific needs of niche industries, we design and optimize user experiences that solve real-world problems, streamline workflows, and differentiate your product in competitive markets.</p>
          </animated.div>
        </Box>
        <Box ref={ref2} display="flex" alignItems="flex-start" justifyContent="center" height="100%" mb={2}>
          <animated.div style={{ ...leftSpring3, width: '30%' }}>
            <img src={UXImgHomeFeature3} alt="Sample" style={{ width: '100%' }} />
          </animated.div>
          <animated.div style={{ ...rightSpring3, width: '70%', padding: '20px' }}>
            <Typography variant="h4" style={{ color: 'white' }}>Low Code and Platform Accelerators</Typography>
            <p>At UX Integrity, we specialize in enhancing low-code ecosystems by designing and developing custom plugins, components, and extensions that supercharge platform capabilities. Our solutions are tailored to fit seamlessly into your tech stack, enabling faster launches, easier iteration, and scalable UX patterns that empower both developers and end users.</p>
          </animated.div>
        </Box>
      </Container>
      <Container className='uxi-home-ux-aas-container' style={{ marginTop: '32px', marginBottom: '32px' }}>
        <Typography variant="h2" style={{ color: 'white', fontFamily: 'ethnocentric' }}>UX-as-a-Service</Typography>
        <h3>UX-as-a-Service was developed by UX Integrity to address gaps in UX teams across large to Fortune 500 organizations.</h3>
        <Grid container spacing={2} ref={ref3}>
          <Grid item xs={12}>
            <animated.div style={fadeInSpring1}>
              <div className="uxi-home-card-row">
                <div className="uxi-home-card-row-item-card">
                <img src={UXImgHomeFeature4} alt="..." style={{ width: '100%' }} />
                </div>
                <div className="uxi-home-card-row-item-text">
                  <Typography variant="h4" style={{ color: 'white' }}>Platform-Driven and AI-Powered</Typography>
                  <p>Our UX-as-a-Service solution is platform driven, but with a human in the loop. That means getting the best of both worlds. The speed and range of AI with automation, with the personal attention of a UX professional.</p>
                </div>
              </div>
            </animated.div>
          </Grid>
          <Grid item xs={12}>
            <animated.div style={fadeInSpring2}>
              <div className="uxi-home-card-row">
                <div className="uxi-home-card-row-item-card">
                  <img src={UXImgHomeFeature5} alt="..." style={{ width: '100%' }} />
                </div>
                <div className="uxi-home-card-row-item-text">
                  <Typography variant="h4" style={{ color: 'white' }}>Extend Your Design Team</Typography>
                  <p>UX teams are always strapped for time and resources. Our service can append your team in the critical area of user-centric focus.</p>
                </div>
              </div>
            </animated.div>
          </Grid>
          <Grid item xs={12}>
            <animated.div style={fadeInSpring3}>
              <div className="uxi-home-card-row">
                <div className="uxi-home-card-row-item-card">
                  <img src={UXImgHomeFeature6} alt="..." style={{ width: '100%' }} />
                </div>
                <div className="uxi-home-card-row-item-text">
                  <Typography variant="h4" style={{ color: 'white' }}>See the Entire Picture</Typography>
                  <p>One or a few UX team members can't see the entire scope of your program. However, a platform approach powered by our designers and yours will bring the full program into view.</p>
                </div>
              </div>
            </animated.div>
          </Grid>
          <Grid item xs={12}>
            <animated.div style={fadeInSpring4}>
              <div className="uxi-home-card-row">
                <div className="uxi-home-card-row-item-card">
                  <img src={UXImgHomeFeature7} alt="..." style={{ width: '100%' }} />  
                </div>
                <div className="uxi-home-card-row-item-text">
                  <Typography variant="h4" style={{ color: 'white' }}>Integrate UX with Systems</Typography>
                  <p>Workflow can gain speed and productivity with proper integrations. We have integrations capable with Jira, Teams and other platforms that your team uses every day.</p>
                </div>
              </div>
            </animated.div>
          </Grid>
        </Grid>
      </Container>
      <Container style={{ marginTop: '32px', marginBottom: '32px' }}>
        <Typography variant="h2" style={{ color: 'white', fontFamily: 'ethnocentric' }}>CX Mainstreet</Typography>
        <h3>15 years of experience in Fortune 500 and Federal UX ready for main street.</h3>
        <Box ref={ref4} display="flex" alignItems="flex-start" justifyContent="center" height="100%" mb={2}>
          <animated.div style={{ ...leftSpring4, width: '30%' }}>
            <img src={UXImgHomeFeature8} alt="Sample" style={{ width: '100%' }} />
          </animated.div>
          <animated.div style={{ ...rightSpring4, width: '70%', padding: '20px' }}>
            <Typography variant="h4" style={{ color: 'white' }}>AI Tools Empowering Small Business</Typography>
            <p>We create AI-driven tools that enable small businesses to lead with a user-first mindset. Our approach focuses on center-out organizational change — equipping transformation teams with the insights, frameworks, and technology they need to embed user-centered thinking across every level of the business.</p>
          </animated.div>
        </Box>
        <Box ref={ref4} display="flex" alignItems="flex-start" justifyContent="center" height="100%" mb={2}>
          <animated.div style={{ ...leftSpring5, width: '30%' }}>
            <img src={UXImgHomeFeature9} alt="Sample" style={{ width: '100%' }} />
          </animated.div>
          <animated.div style={{ ...rightSpring5, width: '70%', padding: '20px' }}>
            <Typography variant="h4" style={{ color: 'white' }}>Tailored for Industry Use Cases</Typography>
            <p>At UX Integrity, we design AI tools that are purpose-built for the industries they serve — addressing unique workflows, compliance needs, and user expectations. By aligning AI capabilities with real-world industry challenges, we help businesses unlock smarter, faster, and more intuitive solutions that drive meaningful impact.</p>
          </animated.div>
        </Box>
      </Container>
      <Container id="last-section" style={{ marginTop: '32px', marginBottom: '32px' }}>
        <Typography variant="h2" style={{ color: 'white', fontFamily: 'ethnocentric' }}>Diverse Experience</Typography>
        <h3>Experience in challenging, complex programs impacting hundreds of thousands of users.</h3>
        <Box ref={ref5} display="flex" alignItems="flex-start" justifyContent="center" height="100%" mb={2}>
          <animated.div style={{ ...leftSpring6, width: '50%' }}>
            <img src={UXImgHomeFeature10} alt="Large Sample" style={{ width: '100%' }} />
          </animated.div>
          <animated.div style={{ ...rightSpring6, width: '50%', padding: '20px' }}>
            <Typography variant="h4" style={{ color: 'white' }}>Designing Critical Systems</Typography>
            <p>UX Integrity has experience with US Census, IRS, SSA, FDA, MasterCard, Sprint, Verizon, Starbucks, Volvo Trucks and more clients with mission-critical systems.</p>
          </animated.div>
        </Box>
      </Container>
      <CompContactWidget />

      {showArrow && (
        <div style={{ position: 'fixed', bottom: '20px', right: '20px', transform: 'rotate(90deg)' }}>
          <DoubleArrowIcon style={{ color: 'white', fontSize: '2rem' }} />
        </div>
      )}
    </div>
  );
}

export default Home;
